import { nav } from "framer-motion/client";
import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button, Modal, Card, Badge } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import LocationAutocompleteTransport from "../LocationAutocompleteTransport";
import { userAPI } from "../../api/apiSystem";
import { useTranslation } from "react-i18next";

import paletteImg from '../../assets/images/transport_form_icon/palette.png';
import paketeImg from '../../assets/images/transport_form_icon/pakete.png';
import documentImg from '../../assets/images/transport_form_icon/document.png';
import furnitureImg from '../../assets/images/transport_form_icon/furniture.png';
import electricalImg from '../../assets/images/transport_form_icon/electrical.png';
import tiresImg from '../../assets/images/transport_form_icon/tires.png';
import refrigeratorImg from '../../assets/images/transport_form_icon/refrigerator.png';
import buildingMaterialsImg from '../../assets/images/transport_form_icon/building_materials.png';
import movingImg from '../../assets/images/transport_form_icon/moving.png';
import bicycleImg from '../../assets/images/transport_form_icon/bicycle.png';
import motorcycleImg from '../../assets/images/transport_form_icon/motorcycle.png';
import carImg from '../../assets/images/transport_form_icon/car.png';
import animalTransportImg from '../../assets/images/transport_form_icon/animal_transport.png';
import otherImg from '../../assets/images/transport_form_icon/other.png';
import { MdLocationCity, MdLocationOn } from "react-icons/md";

// Categorized transport options based on the design
const transportCategories = [
  {
    // category: "transportModal.categories.general",
    category: "",
    options: [
      { name: "palette", label: "palette", img: paletteImg, popular: true },
      { name: "pakete", label: "pakete", img: paketeImg, popular: true },
      { name: "document", label: "document", img: documentImg, popular: true },
      { name: "moving", label: "moving", img: movingImg },
      { name: "furniture", label: "furniture", img: furnitureImg },
      // { name: "other", label: "Sonstige", img: otherImg, isOther: true },
      { name: "electrical", label: "electrical", img: electricalImg },
    ]
  },
  {
    // category: "transportModal.categories.household",
    category: "",
    options: [
      { name: "building materials", label: "building materials", img: buildingMaterialsImg },
      { name: "tires", label: "tires", img: tiresImg },
      { name: "animal transport", label: "animal transport", img: animalTransportImg },
    ]
  },
  {
    // category: "transportModal.categories.vehicles",
    category: "",
    options: [
      { name: "motorcycle", label: "motorcycle", img: motorcycleImg },
      { name: "car", label: "car", img: carImg },
      { name: "bicycle", label: "bicycle", img: bicycleImg },
      { name: "other", label: "other", img: otherImg },
    ]
  },
 
];

// Flat list for backwards compatibility
const transportOptions = transportCategories.flatMap(cat => cat.options);

export default function TransportForm({
  // selectedTransport,
  // setSelectedTransport,
  autoOpenTransportSelector = false,
  goToStep,

}) {
  const [selectedTransport, setSelectedTransport] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [tempSelection, setTempSelection] = useState(selectedTransport);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [isValidDistance, setIsValidDistance] = useState(false);
  const autoOpenedRef = useRef(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!autoOpenTransportSelector || autoOpenedRef.current) return;

    autoOpenedRef.current = true;

    const typeFromUrl = searchParams.get("type");
    if (!typeFromUrl) {
      setTempSelection(selectedTransport);
      setShowModal(true);
    }
    
  }, [autoOpenTransportSelector, selectedTransport]);


  useEffect(() => {
    const typeFromUrl = searchParams.get("type");
    if (typeFromUrl) {
      const found = transportOptions.find(opt => opt.name === typeFromUrl);
      if (found) {
        setSelectedTransport(found);
        // لو عندك form state، حطه هنا
        // setFormData(prev => ({...prev, transportType: found.name}));
      }
    }
  }, [searchParams]);

  const handleSelect = (option) => {
    setTempSelection(option);
    setTimeout(() => {
      setSelectedTransport(option);
      setShowModal(false);
    }, 200);
  };

  const [formData, setFormData] = useState({
    booking_from: "",
    booking_to: "",
    vehicle_id: "",
  });

  useEffect(() => {
    const { booking_from, booking_to } = formData;

    if (booking_from && booking_to) {
      const fetchPrice = async () => {
        setLoading(true);
        setError("");
        setIsValidDistance(false);
        
        try {

          const dataToSend = {
            booking_from: booking_from,
            booking_to: booking_to,
            from_lat_long: data.from_lat_long,
            to_lat_long: data.to_lat_long,

          };

          console.log("📦 Sending data to calculate-home:", dataToSend);

          const res = await userAPI.transports.calculateHome(dataToSend);
          if(res?.data){
            setData(res?.data?.data);
          }

          if (res.success) {
            setError("");
            setIsValidDistance(true);
          } else {
            setIsValidDistance(false);
            setError(t('price.errors.unableToCalculate'));
          }
        } catch (error) {
          setIsValidDistance(false);
          setError(t('price.errors.calculationError'));
        } finally {
          setLoading(false);
        }
      };

      fetchPrice();
    } else {
      setIsValidDistance(false);
      setError("");
    }
  }, [formData.booking_from, formData.booking_to]);
  const isButtonDisabled = loading || !isValidDistance ||  !formData.booking_from || !formData.booking_to || !selectedTransport;
  const handleSubmit = (e) => {
    e.preventDefault(); 
    if (!selectedTransport) return alert("⚠️ لازم تختار نوع النقل الأول");
    if (!formData.booking_from || !formData.booking_to) return alert("⚠️ لازم تدخل عنوان التحميل والتسليم");

    navigate("/transport-form", {
      state: {
        transportType: selectedTransport,
        locations: { booking_from: formData.booking_from, booking_to: formData.booking_to, from_lat_long: data.from_lat_long, to_lat_long: data.to_lat_long },
      },
    });
  };

  const handleLocationChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      ...(e.lat && { [`${e.target.name}_lat`]: e.lat }),
      ...(e.lng && { [`${e.target.name}_lng`]: e.lng }),
    }));
    setError("");
    setIsValidDistance(false);
  };
  return (
    <>
      <Form className="quote-form" onSubmit={handleSubmit} style={{ marginTop: "-13em" }}>
        {/* Title & Subtitle */}
        <div className="text-start ">
          <h2 className="fw-bold mb-2 text-xl" >
            {t("transportForm.title")}
          </h2>
          <p className="text-muted mb-0 text-lg">
            {t("transportForm.subtitle")}
          </p>
        </div>

        <Row className="g-3 align-items-center justify-content-center mt-2">
          <Col md={4} xs={12}>
            <Form.Label className="fw-semibold mb-2 text-muted">{t("transportForm.question")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("transportForm.selectPlaceholder")}
              value={selectedTransport ? t(selectedTransport.label) : ""}
              readOnly
              onClick={() => setShowModal(true)}   // لو عندك modal محلي
              className="border-orange-500 cursor-pointer bg-white"
            />
          </Col>
          <Col md={4} xs={12}>
            <Form.Group controlId="formFrom">
            
              <Form.Label className="fw-semibold mb-2 text-muted">{t("transportForm.pickupLabel")}</Form.Label>
              <LocationAutocompleteTransport
                name="booking_from"
                value={formData.booking_from}
                onChange={handleLocationChange}
                // placeholder={t("transportForm.pickupPlaceholder")}
                placeholder={t("enter_address")}
              />
            </Form.Group>
          </Col>

          <Col md={4} xs={12}>
            <Form.Group controlId="formTo">
              <Form.Label className="fw-semibold mb-2 text-muted">{t("transportForm.deliveryLabel")}</Form.Label>
              <LocationAutocompleteTransport
                name="booking_to"
                value={formData.booking_to}
                onChange={handleLocationChange}
                placeholder={t("enter_address")}
              />
            </Form.Group>
          </Col>

          <Col lg={8} xs={12}>  
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-3 bg-light rounded">
              <div className="text-center text-md-start">
                { error ? (
                  <div className="mb-2 text-danger" dangerouslySetInnerHTML={{__html:error}}/>
                ) : (
                  <small className="text-muted">
                    <span className="  text-orange fs-4 mx-1"><MdLocationOn  /></span>
                    {t("transportForm.availableLocations")} <a href="/loading-city" className="text-orange text-decoration-underline">{t("transportForm.show")}</a>
                  </small>
                )}
              </div>

              <div className="text-center">
                <p className="text-muted mb-2 small">{t("transportForm.freeText")}</p>
                <Button
                  type="submit"
                  size="lg"
                  className="bg-orange-500 text-white flex-shrink-0 px-4"
                  style={{ minWidth: "200px" }}
                  disabled={isButtonDisabled}
                >
                  {t("transportForm.continueButton")}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Form>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="transport-type-modal"
      >
        <Modal.Header closeButton className="transport-modal-header">
          <Modal.Title>{t("select_transport_type")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="transport-modal-body">
          {transportCategories.map((category, catIndex) => (
            <div key={catIndex} className="transport-category-section">
              <h6 className="transport-category-title">{t(category.category)}</h6>
              <Row className="g-3 mb-4">
                {category.options.map((option) => (
                  <Col xs={6} md={4} key={option.name}>
                    <Card
                      className={`transport-option-card h-100 text-center p-2 ${
                        tempSelection?.name === option.name
                          ? "selected"
                          : ""
                      } ${option.isOther ? "other-card" : ""}`}
                      onClick={() => handleSelect(option)}
                    >
                      {option.popular && (
                        <Badge className="popular-badge continue-btn-main">{t("transportModal.popular")}</Badge>
                      )}
                      <div className="card-img-wrapper">
                        <Card.Img
                          variant="top"
                          src={option.img}
                          alt={option.label}
                          className="transport-option-img"
                        />
                      </div>
                      
                      <Card.Body className="p-2">
                        <Card.Title className="transport-option-label">{t(option.label)}</Card.Title>
                        {option.isOther && (
                          <small className="text-muted">{t("transportModal.otherDescription")}</small>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
                {/* Add "Weiter" button in the first category row */}
                {/* {catIndex === 0 && (
                  <Col xs={6} md={4} className="d-flex align-items-center justify-content-center">
                    <Button
                      className="continue-btn-inline"
                      onClick={() => setShowModal(false)}
                      disabled={!tempSelection}
                    >
                      {t("transportModal.continue")} →
                    </Button>
                  </Col>
                )} */}
              </Row>
            </div>
          ))}
          
          <div className="text-center mt-3">
            <Button
              className="continue-btn-main"
              onClick={() => setShowModal(false)}
              disabled={!tempSelection}
            >
              {t("transportModal.continue")} →
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
